// src/pages/FinancialReportsPage.js

import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const FinancialReportsPage = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Filter states
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [roomId, setRoomId] = useState('all');

  // Fetch report data based on filters
  const fetchReport = () => {
    setLoading(true);
    
    // Build query string based on selected filters
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());
    if (roomId !== 'all') params.append('roomId', roomId);
    
    fetch(`/api/FinancialReport?${params.toString()}`)
      .then(response => response.json())
      .then(data => {
        setReportData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching report:', error);
        setLoading(false);
      });
  };

  // Fetch initial data on component mount
  useEffect(() => {
    fetchReport();
  }, []);

  // Utility functions for formatting
  const formatCurrency = (value) =>
    value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString('en-US', { month: 'long' });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    fetchReport();
  };

  return (
    <div>
      <h2>Financial Reports</h2>
      
      {/* Filters Form */}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Start Date: </label>
          <DatePicker 
            selected={startDate} 
            onChange={(date) => setStartDate(date)} 
            placeholderText="Select start date" 
          />
        </div>
        <div>
          <label>End Date: </label>
          <DatePicker 
            selected={endDate} 
            onChange={(date) => setEndDate(date)} 
            placeholderText="Select end date" 
          />
        </div>
        <div>
          <label>Room: </label>
          <select value={roomId} onChange={(e) => setRoomId(e.target.value)}>
            <option value="all">All Rooms</option>
            {/* Add specific room options here */}
            <option value="1">Room 1</option>
            <option value="2">Room 2</option>
            {/* ... */}
          </select>
        </div>
        <button type="submit">Get Report</button>
      </form>
      
      {/* Report Display */}
      {loading ? (
        <div>Loading...</div>
      ) : reportData ? (
        <>
          <div>
            <h3>Overview</h3>
            <ul>
              <li><strong>Total Revenue:</strong> {formatCurrency(reportData.totalRevenue)}</li>
              <li><strong>Total Expenses:</strong> {formatCurrency(reportData.totalExpenses)}</li>
              <li><strong>Net Profit:</strong> {formatCurrency(reportData.netProfit)}</li>
              <li><strong>Occupancy Rate:</strong> {reportData.occupancyRate.toFixed(0)}%</li>
            </ul>
          </div>

          <div>
            <h3>Monthly Breakdown</h3>
            <table className="table">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Revenue</th>
                  <th>Expenses</th>
                  <th>Profit</th>
                </tr>
              </thead>
              <tbody>
                {reportData.monthlyBreakdown.map((item, index) => (
                  <tr key={index}>
                    <td>{getMonthName(item.month)}</td>
                    <td>{formatCurrency(item.revenue)}</td>
                    <td>{formatCurrency(item.expenses)}</td>
                    <td>{formatCurrency(item.profit)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div>No data available</div>
      )}
    </div>
  );
};

export default FinancialReportsPage;
